function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}




var $b2dead5224070971$exports = {};
/**
 * @license MIT
 * topbar 2.0.0, 2023-02-04
 * http://buunguyen.github.io/topbar
 * Copyright (c) 2021 Buu Nguyen
 */ (function(window1, document1) {
    "use strict";
    function repaint() {
        canvas.width = window1.innerWidth, canvas.height = 5 * options.barThickness;
        var ctx = canvas.getContext("2d");
        ctx.shadowBlur = options.shadowBlur, ctx.shadowColor = options.shadowColor;
        var stop, lineGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
        for(stop in options.barColors)lineGradient.addColorStop(stop, options.barColors[stop]);
        ctx.lineWidth = options.barThickness, ctx.beginPath(), ctx.moveTo(0, options.barThickness / 2), ctx.lineTo(Math.ceil(currentProgress * canvas.width), options.barThickness / 2), ctx.strokeStyle = lineGradient, ctx.stroke();
    }
    var canvas, currentProgress, showing, progressTimerId = null, fadeTimerId = null, delayTimerId = null, options = {
        autoRun: !0,
        barThickness: 3,
        barColors: {
            0: "rgba(26,  188, 156, .9)",
            ".25": "rgba(52,  152, 219, .9)",
            ".50": "rgba(241, 196, 15,  .9)",
            ".75": "rgba(230, 126, 34,  .9)",
            "1.0": "rgba(211, 84,  0,   .9)"
        },
        shadowBlur: 10,
        shadowColor: "rgba(0,   0,   0,   .6)",
        className: null
    }, topbar = {
        config: function(opts) {
            for(var key in opts)options.hasOwnProperty(key) && (options[key] = opts[key]);
        },
        show: function(handler) {
            var type, elem;
            showing || (handler ? delayTimerId = delayTimerId || setTimeout(()=>topbar.show(), handler) : (showing = !0, null !== fadeTimerId && window1.cancelAnimationFrame(fadeTimerId), canvas || ((elem = (canvas = document1.createElement("canvas")).style).position = "fixed", elem.top = elem.left = elem.right = elem.margin = elem.padding = 0, elem.zIndex = 100001, elem.display = "none", options.className && canvas.classList.add(options.className), document1.body.appendChild(canvas), type = "resize", handler = repaint, (elem = window1).addEventListener ? elem.addEventListener(type, handler, !1) : elem.attachEvent ? elem.attachEvent("on" + type, handler) : elem["on" + type] = handler), canvas.style.opacity = 1, canvas.style.display = "block", topbar.progress(0), options.autoRun && function loop() {
                progressTimerId = window1.requestAnimationFrame(loop), topbar.progress("+" + .05 * Math.pow(1 - Math.sqrt(currentProgress), 2));
            }()));
        },
        progress: function(to) {
            return void 0 === to || ("string" == typeof to && (to = (0 <= to.indexOf("+") || 0 <= to.indexOf("-") ? currentProgress : 0) + parseFloat(to)), currentProgress = 1 < to ? 1 : to, repaint()), currentProgress;
        },
        hide: function() {
            clearTimeout(delayTimerId), delayTimerId = null, showing && (showing = !1, null != progressTimerId && (window1.cancelAnimationFrame(progressTimerId), progressTimerId = null), function loop() {
                return 1 <= topbar.progress("+.1") && (canvas.style.opacity -= .05, canvas.style.opacity <= .05) ? (canvas.style.display = "none", void (fadeTimerId = null)) : void (fadeTimerId = window1.requestAnimationFrame(loop));
            }());
        }
    };
    "object" == typeof $b2dead5224070971$exports ? $b2dead5224070971$exports = topbar : "function" == typeof define && define.amd ? define(function() {
        return topbar;
    }) : this.topbar = topbar;
}).call($b2dead5224070971$exports, window, document);


function $051192e162264caf$export$2fa187e846a241c4(string) {
    return document.querySelector(string);
}
function $051192e162264caf$export$dcd0d083aa86c355(string) {
    return document.querySelectorAll(string);
}


const $fbdd751d522ba83d$var$clock = document.querySelector(".clock");
const $fbdd751d522ba83d$var$second_hand = document.querySelector(".hand.second");
const $fbdd751d522ba83d$var$minute_hand = document.querySelector(".hand.minute");
const $fbdd751d522ba83d$var$hour_hand = document.querySelector(".hand.hour");
const $fbdd751d522ba83d$var$time = document.querySelector(".time");
let $fbdd751d522ba83d$var$seconds = 0;
let $fbdd751d522ba83d$var$minutes = 0;
let $fbdd751d522ba83d$var$hours = 0;
let $fbdd751d522ba83d$var$request_interval;
// #region clock-functions
function $fbdd751d522ba83d$var$initClock() {
    const date = new Date();
    $fbdd751d522ba83d$var$seconds = date.getSeconds();
    $fbdd751d522ba83d$var$minutes = date.getMinutes();
    $fbdd751d522ba83d$var$hours = date.getHours() % 12 * 5 + Math.floor($fbdd751d522ba83d$var$minutes / 12);
    $fbdd751d522ba83d$var$rotateSecondHand();
    $fbdd751d522ba83d$var$rotateMinuteHand();
    $fbdd751d522ba83d$var$rotateHourHand();
    $fbdd751d522ba83d$var$startClock();
}
function $fbdd751d522ba83d$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $fbdd751d522ba83d$var$incrementSecond() {
    $fbdd751d522ba83d$var$seconds = ++$fbdd751d522ba83d$var$seconds % 60;
    $fbdd751d522ba83d$var$seconds === 0 && $fbdd751d522ba83d$var$incrementMinute();
}
function $fbdd751d522ba83d$var$incrementMinute() {
    $fbdd751d522ba83d$var$minutes = ++$fbdd751d522ba83d$var$minutes % 60;
    $fbdd751d522ba83d$var$minutes % 12 === 0 && $fbdd751d522ba83d$var$incrementHour();
}
function $fbdd751d522ba83d$var$incrementHour() {
    $fbdd751d522ba83d$var$hours = ++$fbdd751d522ba83d$var$hours % 60;
}
function $fbdd751d522ba83d$var$rotateSecondHand(second = $fbdd751d522ba83d$var$seconds) {
    const secondDegree = second * 6;
    $fbdd751d522ba83d$var$second_hand.setAttribute("data-value", $fbdd751d522ba83d$var$prefixZero(second));
    $fbdd751d522ba83d$var$second_hand.style.setProperty("--degree", secondDegree + "deg");
    $fbdd751d522ba83d$var$clock.style.setProperty("--degree", secondDegree + "deg");
}
function $fbdd751d522ba83d$var$rotateMinuteHand(minute = $fbdd751d522ba83d$var$minutes) {
    const minuteDegree = minute * 6;
    $fbdd751d522ba83d$var$minute_hand.style.setProperty("--degree", minuteDegree + "deg");
    $fbdd751d522ba83d$var$minute_hand.setAttribute("data-value", $fbdd751d522ba83d$var$prefixZero(minute));
}
function $fbdd751d522ba83d$var$rotateHourHand(hour = $fbdd751d522ba83d$var$hours) {
    const hourDegree = hour * 6;
    $fbdd751d522ba83d$var$hour_hand.style.setProperty("--degree", hourDegree + "deg");
    $fbdd751d522ba83d$var$hour_hand.setAttribute("data-value", $fbdd751d522ba83d$var$prefixZero(Math.floor(hour / 5) || 12));
}
function $fbdd751d522ba83d$var$rotateHands() {
    $fbdd751d522ba83d$var$incrementSecond();
    $fbdd751d522ba83d$var$rotateSecondHand();
    $fbdd751d522ba83d$var$rotateMinuteHand();
    $fbdd751d522ba83d$var$rotateHourHand();
}
function $fbdd751d522ba83d$var$startClock() {
    $fbdd751d522ba83d$var$request_interval = setInterval($fbdd751d522ba83d$var$rotateHands, 1000);
}
function $fbdd751d522ba83d$var$stopClock() {
    clearInterval($fbdd751d522ba83d$var$request_interval);
}
// #endregion clock-functions
function $fbdd751d522ba83d$var$setWaveAnimationPlayState(state) {
    $fbdd751d522ba83d$var$clock.style.setProperty("--waves-play-state", state);
}
function $fbdd751d522ba83d$var$prefixZero(number) {
    return number >= 10 ? number.toString() : number.toString().padStart(2, "0");
}
function $fbdd751d522ba83d$var$onCustomTimeChange(time) {
    // time format = HH:mm
    console.log({
        time: time
    });
    let [_hours, _minutes] = time.split(":").map(Number);
    _hours = _hours % 12 * 5 + Math.floor(_minutes / 12);
    $fbdd751d522ba83d$var$stopClock();
    $fbdd751d522ba83d$var$rotateSecondHand(0);
    $fbdd751d522ba83d$var$rotateMinuteHand(_minutes);
    $fbdd751d522ba83d$var$rotateHourHand(_hours);
    $fbdd751d522ba83d$var$seconds = 0;
    $fbdd751d522ba83d$var$minutes = _minutes;
    $fbdd751d522ba83d$var$hours = _hours;
    $fbdd751d522ba83d$var$startClock();
}
function $fbdd751d522ba83d$export$79cbf9627295004e() {
    $fbdd751d522ba83d$var$clock.style.display = "none";
}
function $fbdd751d522ba83d$export$2755f4ae05886c9b() {
    $fbdd751d522ba83d$var$clock.style.display = "block";
}
$fbdd751d522ba83d$var$initClock();


(0, (/*@__PURE__*/$parcel$interopDefault($b2dead5224070971$exports))).show();
(0, (/*@__PURE__*/$parcel$interopDefault($b2dead5224070971$exports))).config({
    shadowColor: "rgba(0, 0, 0, .1)"
});
const $ac43a74d429af77f$var$loadingElement = (0, $051192e162264caf$export$2fa187e846a241c4)`#loading`;
const $ac43a74d429af77f$var$heroSection = (0, $051192e162264caf$export$2fa187e846a241c4)`#hero`;
const $ac43a74d429af77f$var$header = (0, $051192e162264caf$export$2fa187e846a241c4)`header`;
document.onreadystatechange = function() {
    if (document.readyState === "complete") setTimeout(()=>{
        $ac43a74d429af77f$var$loadingElement.style.display = "none";
        (0, (/*@__PURE__*/$parcel$interopDefault($b2dead5224070971$exports))).hide();
    }, 1800);
};
const $ac43a74d429af77f$var$heroSectionObserver = new IntersectionObserver(function(entries, heroSectionObserver) {
    entries.forEach((entry)=>{
        if (!entry.isIntersecting) $ac43a74d429af77f$var$header.classList.add("header-scrolled");
        else $ac43a74d429af77f$var$header.classList.remove("header-scrolled");
    });
}, {
    rootMargin: "-90% 0px 0px 0px"
});
$ac43a74d429af77f$var$heroSectionObserver.observe($ac43a74d429af77f$var$heroSection);
const $ac43a74d429af77f$var$tech_stack = (0, $051192e162264caf$export$2fa187e846a241c4)`.tech-stack`;
const $ac43a74d429af77f$var$tech_stack_svgs = (0, $051192e162264caf$export$dcd0d083aa86c355)`.tech-stack svg`;
const $ac43a74d429af77f$var$tech_name_div = (0, $051192e162264caf$export$2fa187e846a241c4)`.tech-stack-name`;
const $ac43a74d429af77f$var$tech_mirror_shadow = (0, $051192e162264caf$export$2fa187e846a241c4)`.mirror-shadow`;
$ac43a74d429af77f$var$tech_stack_svgs.forEach((svg)=>{
    svg.addEventListener("mouseenter", $ac43a74d429af77f$var$onTechMouseEnter(svg.dataset.techname));
    svg.addEventListener("mouseleave", $ac43a74d429af77f$var$onTechMouseLeave());
});
function $ac43a74d429af77f$var$onTechMouseEnter(name) {
    return ()=>{
        const t = $ac43a74d429af77f$var$tech_name_div;
        t.innerText = name;
        t.style.display = "block";
        $ac43a74d429af77f$var$blurOtherTech(name);
        $ac43a74d429af77f$var$showMirrorShadow(name);
        (0, $fbdd751d522ba83d$export$79cbf9627295004e)();
    };
}
function $ac43a74d429af77f$var$showMirrorShadow(name) {
    const selected_tech_svg = (0, $051192e162264caf$export$2fa187e846a241c4)(`.tech-stack svg[data-techname="${name}"]`);
    $ac43a74d429af77f$var$tech_mirror_shadow.innerHTML = selected_tech_svg.outerHTML;
    $ac43a74d429af77f$var$tech_mirror_shadow.style.setProperty("--origin-x", "0px");
    $ac43a74d429af77f$var$tech_mirror_shadow.style.setProperty("--origin-y", "-600%");
    $ac43a74d429af77f$var$tech_mirror_shadow.style.setProperty("--origin-scale", "10");
}
function $ac43a74d429af77f$var$onTechMouseLeave() {
    return (event)=>{
        const t = $ac43a74d429af77f$var$tech_name_div;
        t.style.display = "none";
        console.log(event);
        const tech_width = $ac43a74d429af77f$var$tech_stack.getBoundingClientRect().width;
        const translatexCalc = `calc(${event.target.getBoundingClientRect().left}px - ${event.target.parentElement.offsetLeft}px - ${tech_width / 2}px + ${$ac43a74d429af77f$var$tech_mirror_shadow.getBoundingClientRect().width / 20}px)`;
        $ac43a74d429af77f$var$tech_mirror_shadow.style.setProperty("--origin-x", translatexCalc);
        $ac43a74d429af77f$var$tech_mirror_shadow.style.setProperty("--origin-y", "0px");
        $ac43a74d429af77f$var$tech_mirror_shadow.style.setProperty("--origin-scale", "0");
        $ac43a74d429af77f$var$tech_stack_svgs.forEach((svg)=>$ac43a74d429af77f$var$blurElement(svg, false));
        (0, $fbdd751d522ba83d$export$2755f4ae05886c9b)();
    };
}
function $ac43a74d429af77f$var$blurOtherTech(name) {
    $ac43a74d429af77f$var$tech_stack_svgs.forEach((svg)=>{
        svg.dataset.techname !== name && $ac43a74d429af77f$var$blurElement(svg);
    });
}
function $ac43a74d429af77f$var$blurElement({ classList: classList }, apply = true) {
    apply ? classList.add("blur-tech") : classList.remove("blur-tech");
}


//# sourceMappingURL=index.c7d0d9ad.js.map
